import { FlexAligner, Typography } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';

/**
 * Rendered in place of the chart/table when the selected interval has no observations.
 * Kept inside the widget content — not as a `GridWidget` overlay — so the toolbar stays
 * interactive and the interval can be changed without data.
 */
export const BiomassDistributionEmptyState = () => {
  const { t } = useTranslation(['chartConfig']);

  return (
    <FlexAligner alignment='center' fullHeight>
      <Typography type='body_large'>{t('chartConfig:noReadings')}</Typography>
    </FlexAligner>
  );
};
